import { Navigate } from 'react-router-dom';
import { SessionService } from '../../../domain/services';
import { Roles } from '../../../utils/roles';
import { useUserService } from '../../hooks';

const Landing = () => {
  const UserService = useUserService();

  if (!SessionService.isAuthenticated()) return <Navigate to='/login' replace />;

  if (UserService.hasRole(Roles.secretary)) return <Navigate to='/citas' replace />;

  if (UserService.hasRole(Roles.doctor)) return <Navigate to='/consultas' replace />;

  return <div />;
};

export default Landing;
